import { useTranslation } from "react-i18next";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export default function DeviceStatus() {
  const { t } = useTranslation();

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">
          {t("deviceStatus")}
        </h1>
        <p className="text-muted-foreground">
          Check the current status of your GPSBox device
        </p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Device Information</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-muted-foreground">
            Device status details will be implemented here.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
